<template>
  <div id="footer" class="container-fluid">
    <div class="s-bottom">
      <ul>
        <li>
          <a href="index.html">首页</a>
        </li>
        <li>
          <a href="product.html">产品</a>
        </li>
        <li>
          <a href="case.html">案例</a>
        </li>
        <li>
          <a href="news.html">新闻</a>
        </li>
        <li>
          <a href="company.html">公司</a>
        </li>
      </ul>
      <ul>
        <li>
          <a href="">联系电话：021-623 38327</a>
          <span></span>
        </li>
        <li>
          <a href="">Email：info@vsteach.com</a>
          <span></span>
        </li>
        <li>
          <a href="">公司地址：上海市长宁区福泉北路518号IBP国际商务花园二期3座403室</a>
        </li>
        <li>
          <a href="">Copyright © 2023 www.vsteach.com 上海巅思智能科技有限公司 版权所有 All Rights Reserved.</a>
          <span class="last-s"></span>
        </li>
        <li>
          <a href="">备案号：沪ICP备19043806号-1</a>
        </li>
      </ul>
    </div>
    <div class="qr-code">
      <p>关注巅思官方公众号</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  margin-top: 0;
  width: 100%;
  height: 300px;
  background: rgb(55, 61, 65);
  display: flex;
  position: relative;
  justify-content: space-between;
}


#footer .s-bottom {
  position: absolute;
  left: 9%;
  width: 70%;
  max-width: 1331.39px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

#footer .s-bottom ul:nth-child(1) {
  height: 120px;
  width: 80%;
  display: flex;
  align-items: center;
  border-bottom: 0.5px solid rgb(148, 160, 185);
  padding-bottom: 2%;
  /* border: 1px solid rgb(179, 255, 0); */
}

#footer .s-bottom ul:nth-child(1) li {
  width: 100%;
}

#footer .s-bottom ul:nth-child(1) li a {
  color: rgb(148, 160, 185);
  font-family: "思源黑体 CN";
  font-size: 16px;
  font-weight: 400;
  line-height: 100%;
  letter-spacing: 0px;
  text-align: left;
}

#footer .s-bottom ul:nth-child(2) {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  padding: 0;
  margin-top: 2%;

}

#footer .s-bottom ul:nth-child(2) li {
  width: 280px;
  height: 40px;
}

#footer .s-bottom ul:nth-child(2) li:nth-child(3) {
  width: 440px;
}

#footer .s-bottom ul:nth-child(2) li:nth-child(4) {
  width: 580px;
}

#footer .s-bottom ul:nth-child(2) li a {
  color: rgb(148, 160, 185);
  font-family: "思源黑体 CN";
  font-size: 12px;
  font-weight: 400;
  line-height: 100%;
  letter-spacing: 0px;
  text-align: left;
}

#footer .s-bottom ul:nth-child(2) li span {
  margin-left: 20%;
  border-right: 1px solid rgb(148, 160, 185);
  background: rgb(245, 248, 255);
}

#footer .s-bottom ul:nth-child(2) li .last-s {
  margin-left: 5%;
  border-right: 1px solid rgb(148, 160, 185);
  background: rgb(245, 248, 255);
}

#footer .qr-code {
  position: absolute;
  right: 15%;
  top: 35%;
  width: 104.47px;
  height: 104.47px;
  background: url("../../src/assets/img/ds-img/巅思公众号er.jpg.png") no-repeat;
  z-index: 99;
}

.qr-code p {
  width: 108px;
  color: rgb(185, 170, 148);
  font-family: "思源黑体 CN";
  font-size: 12px;
  font-weight: 400;
  line-height: 100%;
  letter-spacing: 0px;
  text-align: center;
  position: absolute;
  bottom: -25px;
}

</style>



// WEBPACK FOOTER //
// src/components/Footer.vue